import React from 'react'

import style from './MyhouseRegisterRestrictSnsIdPopup.module.scss'

type Props = {
  userNickName: any
  onButtonClick: any
}

const MyhouseRegisterRestrictSnsIdPopup: React.FC<Props> = ({ userNickName, onButtonClick }: Props) => {
  return (
    <div className={`dimmed ${style['type_myhouse']}`}>
      <div className={`${style['myhouse_popup']} ${style['type_complete']}`}>
        <div className={style.myhouse_popup_inner}>
          <strong>
            <h3 className={style.myhouse_popup_title}>서비스 이용이 제한되었습니다.</h3>
            <p className={style.myhouse_popup_text}>{userNickName}님은 소셜ID 회원으로 우리집을 등록할 수 없습니다.</p>
          </strong>
        </div>
        <button className={style.myhouse_popup_close} type="button" onClick={onButtonClick}>
          확인
        </button>
      </div>
    </div>
  )
}

export default MyhouseRegisterRestrictSnsIdPopup
